import React, { useState, useContext, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

import { ReactComponent as BellIcon } from "../../assets/images/Bell.svg";
import "../../pages/Notification/NotificationLightTheme.scss";
import "../../pages/Notification/NotificationDarkTheme.scss";

import { getAlertDetailsById } from "../../services/index";

import { Drawer } from "rsuite";

import { Context } from "../../Context/AlertContext";
import { ConversationStateContext } from "../../Context/ConversationStateContext";
import { messaging } from "../../services/firebase";
//import { messaging, onMessage } from '../services/firebase'; // adjust path as needed
import {
  getAll,
  getertmessage,
  updateStatus,
} from "../../utils/NotificationUtil";
import { mixpanel } from "../../utils/MixPanelUtil";
import NotificationList from "./NotificationList";
import { ALLALERTS } from "../../navigation/CONSTANTS";
import {
  clearAllNotifications,
  GetNotification,
  GetNotificationRead,
} from "../../services/userAuthServices";
import NotificationItem from "./NotificationItem";
import firebase from "firebase/app";
import "firebase/messaging";
import { Button } from "react-bootstrap";
import { SuccessToast } from "../../CustomHooks/SuccessToast";
import { ErrorToast } from "../../CustomHooks/ErrorToast";

export default function NotificationIcon({
  iconref,
  setIsMenuOpen,
  settabopen,
}) {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [sortedNots, setSortedNots] = useState([]);
  const [count, setCount] = useState(0);

  const [notificationsList, setNotificationList] = useState([]);

  const [alertState, setAlertState] = useContext(Context);
  const { conversationstate, setconversationState } = useContext(
    ConversationStateContext
  );

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setTimeout(() => {
          fetchData();
        }, 1000);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);  // ← Empty deps - register listener only once

  const fetchData = () => {
    try {
      getNotificationList(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onBellIconClick = () => {
    try {
      mixpanel.track("Clicks on Notification Pop Up");
    } catch (error) {
      console.error(error);
    }
    setIsMenuOpen((oldState) => !oldState);
    setOpen(true);
  };

  const mapNots = (snapshot) => {
    let temp = snapshot.val();
    let newNots = [];
    for (let notification in temp) {
      newNots.push({
        key: notification,
        value: temp[notification],
      });
    }
    setNotifications((prev) => (prev = newNots));
  };

  const ertmess = (snapshot) => {
    try {
      let temp = snapshot.val();
      setconversationState([temp]);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const temp = notifications.sort((a, b) => {
      return b.key.localeCompare(a.key);
    });
    setSortedNots(temp);

    const count = temp.reduce(
      (counter, obj) =>
        obj.value.status === "unread" ? (counter += 1) : counter,
      0
    ); // 6
    setCount(count);
  }, [notifications]);

  useEffect(() => {
    const handleFCMNotification = (event) => {
      console.log("Notification received in component:", event.detail);
      //setNotification(event.detail); // you can update state here
      const { title, body } = event.detail.notification || {};
      getNotificationList(false);
      // if (Notification.permission === "granted") {
      //   new Notification(title, {
      //     body: body,
      //     icon: "", // or your custom icon
      //     requireInteraction: true,
      //   });
      // } else {
      //   Notification.requestPermission().then((permission) => {
      //     if (permission === "granted") {
      //       new Notification(title, {
      //         body: body,
      //         icon: "", // or your custom icon
      //         requireInteraction: true,
      //       });
      //     } else {
      //       console.warn("Notification permission not granted.");
      //     }
      //   });
      // }
    };

    window.addEventListener("fcm-notification", handleFCMNotification);

    // Clean up listener on unmount
    return () => {
      window.removeEventListener("fcm-notification", handleFCMNotification);
    };
  }, []);

  messaging.onMessage((payload) => {
    if (payload != undefined && payload != null) {
      if (payload?.data?.body != undefined) {
        var IsAlertNotification = payload.data.body
          .toLowerCase()
          .includes("alert");
        if (IsAlertNotification == true) {
          refreshAlertList(payload.data.body);
        }
      }
    }
  });

  //refresh alert list on new notification arrival (only alert notifications)
  function refreshAlertList(notificationmessage) {
    //tejasvini old app->17-03-2021 new app->07-10-2021
    if (location != undefined && location != null) {
      if (location.pathname != undefined && location.pathname != null) {
        if (location.pathname === ALLALERTS) {
          var alertid = notificationmessage.split("AlertID: ");
          const data = getAlertDetailsById(alertid[1]);
          if (data != undefined) {
            data.then((resp) => {
              if (resp != undefined) {
                if (resp.status == "Ok") {
                  try {
                    if (alertState) {
                      if (resp.message.length > 0) {
                        var newalert = alertState.find(
                          (x) => x.alertId == resp.message[0].alertId
                        );
                        if (newalert) {
                          return;
                        }
                        var newalertobj = NewAlertObject(resp.message[0]);
                        setAlertState([newalertobj, ...alertState]);
                      }
                    }
                  } catch (error) {
                    console.error(error);
                  }
                } else {
                  console.log(resp.message);
                }
              }
            });
          }
        }
      }
    }
  }

  const NewAlertObject = (alertobj) => {
    try {
      var alertobj = {
        alertId: alertobj.alertId,
        alertSource: alertobj.alertSource,
        reqActualTime: alertobj.actualTime,
        severity: alertobj.severity,
        actualTime: alertobj.actualTime,
        closedBy: alertobj.closedBy,
        closedOn: alertobj.closedOn,
        userName: alertobj.userName,
        branchId: alertobj.branchId,
        workflowName: alertobj.workflowName,
        status: alertobj.status,
        alertType: alertobj.alertType,
        receivedTime: alertobj.receivedTime,
        modifiedOn: alertobj.modifiedOn,
        metadata: alertobj.metadata,
        siteName: alertobj.site,
        alertCode: alertobj.alertCode,
        deviceId: alertobj.deviceId,
        assignedTo: alertobj.assignedTo,
        zoneType: alertobj.zoneType,
        deviceTypeID: alertobj.deviceTypeID,
        cameraSource: alertobj.cameraSource,
      };
      return alertobj;
    } catch (error) {
      console.error("NewAlertObject Error: ", error);
      return null;
    }
  };

  const NavigatetoAlertDetailsPage = (mess, key) => {
    try {
      updateStatus(key, "read");
      settabopen(false);
      var alertid = mess.split("AlertID: ")[1];
      history.push(`/alertdetails/${alertid}`);
    } catch (error) {
      console.error(error);
    }
  };

  const markAsRead = (key) => {
    updateStatus(key, "read");
  };

  const handleClearAll = () => {
    let loggedInUser = JSON.parse(localStorage.getItem("user"));
    clearAllNotifications(loggedInUser?.Id)
      .then((res) => {
        if (res.Status === "success") {
          SuccessToast("All notifications cleared successfully");
          getNotificationList(false);
        }
        else{
          ErrorToast("Error in clearing notifications");
        }
      })
      .catch((err) => console.log(err));
  };

  const getNotificationList = (showNotify) => {
    let loggedInUser = JSON.parse(localStorage.getItem("user"));
    GetNotification(loggedInUser?.Id)
      .then((res) => {
        if (res.Status == "success") {
          setNotificationList(res.Data);
          document.getElementsByClassName("badge")[0].innerText =
            res.Data.length > 99 ? "99+" : res.Data.length;
        } else {
          setNotificationList([]);
        }
        if (showNotify) {
          setIsMenuOpen((oldState) => !oldState);
          setOpen(true);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="topNotification" ref={iconref}>
      <a onClick={() => getNotificationList(true)}>
        <span className="badge badge-pill badge-danger ml-1 mt-1">
          {notificationsList.length > 99 ? "99+" : notificationsList.length}
        </span>
        <BellIcon
          style={{ cursor: "pointer" }}
          height={20}
          className="BellIconStyle"
        ></BellIcon>
      </a>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        size="xs"
        className="NotificationDrawer"
      >
        <Drawer.Header>
          <Drawer.Title>
            <div className="Not_Header">
               <div className="d-flex">
                <p>
                  Notification(
                  <span className="badgenotify">
                    {notificationsList.length}
                  </span>){" "}
                </p>
              </div>

              <div className="d-flex" style={{alignItems:"center", gap:"10px"}}>
                <p style={{ color: "#0b70d1", marginLeft: "10px" }}>
                  (<span className="badgeUnread">{notificationsList.length}</span>{" "}
                  unread )
                </p>
                <Button 
                  variant="outlined" 
                  size="small" 
                  className="ClearTextBtn" 
                  onClick={handleClearAll}
                  disabled={!notificationsList || notificationsList.length === 0}
                >
                  Clear All
                </Button>
              </div>
            </div>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <div className="NotificationListHgtDiv">
            {notificationsList?.map((item) => (
              <NotificationItem item={item} />
            ))}
          </div>
        </Drawer.Body>
      </Drawer>
    </div>
  );
}
